const BrowserEnums = {
  CHROME: "Chrome",
  FIREFOX: "Firefox",
  EDGE: "Edge",
  SAFARI: "Safari",
};

export default BrowserEnums;
